import React, { memo } from 'react';
import Globe from '@atlaskit/icon/core/migration/globe--world';
import { DEFAULT_BACKGROUND_CONFIG } from '@atlassian/jira-custom-theme-constants/src/constants.tsx';
import type { OverviewTheme } from '@atlassian/jira-custom-theme-constants/src/types.tsx';
import { WRAPPER } from './styled.tsx';
import type { Size } from './types.tsx';

type Props = {
	size?: Size;
	className?: string;
	themeName?: NonNullable<OverviewTheme['themeSetting']>['value'] | null;
};

const OverviewIcon = ({ size = 'medium', className, themeName }: Props) => {
	const theme = themeName ?? DEFAULT_BACKGROUND_CONFIG.name;

	const Wrapper = WRAPPER[size][theme];

	return (
		<Wrapper
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={className}
			data-testid="business-entity-overview.common.ui.overview-icon"
		>
			<Globe label="" LEGACY_size={size} color="currentColor" />
		</Wrapper>
	);
};

export default memo(OverviewIcon);
